import axios from 'axios';

const API_BASE_URL = 'https://dados.mma.gov.br/api/3'; // Substitua pela URL base correta da API

const API_KEY = '277171f0435e2b7edee336d51f84bc5b';

export const getCitySuggestions = async (query) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/municipios`, {
      params: { nome: query },
      headers: {
        'chave-api-dados': API_KEY,
      },
    });
    return response.data; // Ajuste conforme o formato da resposta da API
  } catch (error) {
    console.error('Erro ao buscar sugestões:', error);
    throw error;
  }
};

export const searchCity = async (cityId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/municipios/${cityId}`, {
      headers: {
        'chave-api-dados': API_KEY,
      },
    });
    return response.data; // Ajuste conforme o formato da resposta da API
  } catch (error) {
    console.error('Erro ao buscar dados do município:', error);
    throw error;
  }
};









const testAPI = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}`, {
      headers: {
        'chave-api-dados': API_KEY,
      },
    });
    console.log('Resposta da API:', response.data);
  } catch (error) {
    console.error('Erro ao testar a API:', error.response ? error.response.data : error.message);
  }
};

// Chame a função de teste
testAPI();